import { configQuery } from '@gig/magic-common';
import { CLOUDFLARE_QUERY } from '@gig/magic-messages';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class CloudflareService {
  constructor() {
    this.response = "";
    this.registerQuery();
  }
  registerQuery() {
    window.queryBus.subscribe(CLOUDFLARE_QUERY, (event) => __async(this, null, function* () {
      if (!this.response) {
        this.response = yield this.getResponse();
      }
      const property = event.payload;
      if (!property) {
        return this.response;
      }
      return this.getResponseProperty(property);
    }));
  }
  getResponse() {
    return __async(this, null, function* () {
      const domain = yield configQuery("cloudflareDomain");
      const response = yield fetch(`${domain}/cdn-cgi/trace`);
      return response.text();
    });
  }
  getResponseProperty(property) {
    const part = this.response.split("\n").find((part2) => part2.trim().startsWith(`${property}=`));
    return (part == null ? void 0 : part.split("=")[1]) || "";
  }
}

export { CloudflareService };
